"use client";
import { setConfigValue, sortStore, updateUrl } from "@/components/search/_utils/searchStore";
import { useStore } from "@nanostores/react";
import { useRouter } from "next/navigation";
import { ChevronDownIcon } from "ui/iconsN";

export const data = [
  { label: "Par date croissante", value: "date:asc" },
  { label: "Par date décroissante", value: "date:desc" },
  { label: "Par prix croissant", value: "price:asc" },
  { label: "Par prix décroissant", value: "price:desc" },
];

export const Sort = () => {
  const router = useRouter();
  const sort = useStore(sortStore);

  const handleClick = (sort: string) => {
    setConfigValue({
      type: "sort",
      value: sort,
    });
    updateUrl(router);
  };

  return (
    <div className="relative">
      <select
        className="py-[10px] pl-3 pr-10 rounded-lg border border-bg-2 text-sm/[18px] font-semibold appearance-none cursor-pointer"
        value={sort?.value || ""}
        onChange={(e) => handleClick(e.target.value)}
      >
        {data.map((d) => (
          <option key={d.value} value={d.value}>
            {d.label}
          </option>
        ))}
      </select>
      <ChevronDownIcon className="absolute right-3 top-1/2 -translate-y-1/2 stroke-tx-1" />
    </div>
  );
};
